import { render, staticRenderFns } from "./VPSForgotUserIdEmailSent.vue?vue&type=template&id=5ae16eb2&scoped=true"
import script from "./VPSForgotUserIdEmailSent.vue?vue&type=script&lang=js"
export * from "./VPSForgotUserIdEmailSent.vue?vue&type=script&lang=js"
import style0 from "./VPSForgotUserIdEmailSent.vue?vue&type=style&index=0&id=5ae16eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae16eb2",
  null
  
)

export default component.exports